
import React, { useState, useEffect, useContext, useRef } from "react";

import Footer from "../components/dashboard/footer";
import Header from "../components/dashboard/header";
import SideMenu from "./student/SideMenu";

import tmdbApi from "../api/tmdbApi";
import { useNavigate, Link, useLocation } from "react-router-dom";

import Modal from 'react-bootstrap/Modal';
import SweetAlert from 'react-bootstrap-sweetalert';
import { contentContext } from "../context/contentContext";
import SessionPopup from "./SessionPopup"
import DataTable from 'react-data-table-component';
import Loader from "../components/loader";

import rotate_right from "../assets/images/rotate_right.svg";

import { ToastContainer } from "react-toastify";

import { toast } from "react-toastify";

const Answers = () => {
    // const history = useHistory();
    const navigate = useNavigate()
    const { state } = useLocation();
    const { search } = state || {};

    const [success, setSuccess] = useState(false);


    const [searchvalue, setSearch] = useState("");
    const [answersdata, setAnswers] = useState([]);
    const [formData, setFormData] = useState({
        answer: ""
    });
    const [errorData, setError] = useState({});
    const [errorDisplay, seterrorDisplay] = useState(false);

    const [popup, setShowPopup] = useState(false);
    const [typeSelected, setType] = useState(false);
    const [answerId, setAnswerId] = useState(null);
    const [contentLoaded, setcontentLoaded] = useState(false);

    const [deleteSuccess, setDeleteSuccess] = useState(false);
    const [deleteAnswer, setdeleteAnswer] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [deleteAnswerId, setDeleteAnswerId] = useState(null);

    // const [isLoading, setIsLoading] = useState(false);
    const [showSessionPopupup, setShowSessionPopupup] = useState(false);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(15);
    const [totalRows, setTotalRows] = useState(0);
    // true when the API paged the result; false when it sent every row (table then pages client-side)
    const [serverPaging, setServerPaging] = useState(false);
    const [tableLoading, setTableLoading] = useState(false);
    const [activeSearch, setActiveSearch] = useState(""); // search term the loaded rows belong to
    const requestIdRef = useRef(0);
    const { isLoading, setIsLoading, data, setData, route, setRoute, setActiveMenuId, setActiveMenuObj, GetTimeActivity, isRestricted } = useContext(contentContext)
    const getSerialNumber = (index) => {
        // Serial number calculation: it continues from the last serial number of the previous page
        return (page - 1) * perPage + index + 1;
    };

    const columns = [
        {
            name: 'Sl No',
            selector: (row, index) => getSerialNumber(index),
            sortable: false,
        },
        {
            name: 'Answers',
            selector: row => row?.answer ?? "",
            sortable: true,
            sortFunction: (a, b) => {
                const normalize = str =>
                    (str ?? "")
                        .normalize("NFD")                  // Decompose accented letters
                        .replace(/[\u0300-\u036f]/g, "")   // Remove diacritics
                        .replace(/[^\x00-\x7F]/g, "")      // Remove non-ASCII characters (optional)
                        .toLowerCase();                    // Case-insensitive

                return normalize(a.answer).localeCompare(normalize(b.answer), 'en', { sensitivity: 'base' });
            }
        },

        {
            name: 'Actions',
            cell: (props) => (
                <div className="d-flex">
                    <a

                        className={`text-info action-button ${isRestricted ? "pe-none opacity-50" : ""}`}

                        onClick={(e) => handleEditPopup(e, 'Edit', props)}>
                        <i className="mdi mdi-pencil font-size-18"></i>
                    </a>
                    <a  // className='text-danger action-button'
                        className={`text-info action-button ${isRestricted ? "pe-none opacity-50" : ""}`}
                        onClick={(e) => handleDelete(e, props)}>
                        <i className="mdi mdi-delete font-size-18"></i>
                    </a>
                </div>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];


    const keyForRerender = `${perPage}_${answersdata?.length}`;

    const handlePageChange = (newPage) => {
        // the data table re-fires this on mount (React StrictMode) - ignore when nothing changed
        if (newPage === page) return;
        GetTimeActivity()
        setPage(newPage);
        if (serverPaging) {
            GetAnswersInfo({ page: newPage, search: activeSearch, showLoader: false });
        }
    };

    const handlePerRowsChange = (newPerPage) => {
        if (newPerPage === perPage) return;
        GetTimeActivity()
        setPerPage(newPerPage);
        setPage(1);
        if (serverPaging) {
            GetAnswersInfo({ page: 1, perPage: newPerPage, search: activeSearch, showLoader: false });
        }
    };

    // reload the page the user is on (after add / edit / delete)
    const reloadCurrentPage = () => {
        GetAnswersInfo({ page, search: activeSearch, showLoader: false });
    };


    const handleShowPopup = (e, type) => {
        e.preventDefault()
        setType(type)
        setShowPopup(true);
    };

    const handleClosePopup = () => {
        setFormData((prevData) => ({
            ...prevData, // Keep the other fields intact
            "answer": "", // Update the changed field
        }));
        setShowPopup(false);
        setAnswerId(null)
    }

    const handleEditPopup = (e, type, props) => {
        e.preventDefault()
        setType(type)
        setShowPopup(true);
        setFormData((prevData) => ({
            ...prevData, // Keep the other fields intact
            "answer": props.answer, // Update the changed field
        }));
        setAnswerId(props.answerid)

    };


    useEffect(() => {

        if (!localStorage.getItem("token")) {
            navigate("/");
        }

        GetAnswersInfo({ page: 1 })
    }, []);
    // console.log('dataaaaaaaa',data)

    const customSort = (rows, selector, direction) => {
        const sortedData = rows.slice().sort((rowA, rowB) => {
            // use the selector function to resolve your field names by passing the sort comparators
            // const aField = selector(rowA);
            const aField = String(selector(rowA)).toLowerCase();

            //  const bField = selector(rowB);
            const bField = String(selector(rowB)).toLowerCase();

            let comparison = 0;

            if (aField > bField) {
                comparison = 1;
            } else if (aField < bField) {
                comparison = -1;
            }

            return direction === 'desc' ? comparison * -1 : comparison;
        });

        // Log the sorted data to the console
        // setSortedRecomData(sortedData)
        global.exportExcelData = sortedData
        // console.log('Sorted Data------>:', sortedData);

        return sortedData;
    };


    const handleSearch = async (e) => {
        const inputQuery = searchvalue;

        // ✅ Empty / whitespace-only validation
        if (inputQuery.trim().length === 0) {
            toast.error("Search field cannot be empty.");
            return;
        }

        setPage(1);
        GetAnswersInfo({ page: 1, search: inputQuery.trim() });
    };


    function onConfirm() {
        setSuccess(false);
        setShowPopup(false);
        setFormData((prevData) => ({
            ...prevData,
            "answer": "",
        }))

        reloadCurrentPage()
    };
    // function onConfirm() {
    //     setSuccess(false);
    //     setShowPopup(false);
    //     setFormData((prevData) => ({
    //         ...prevData, // Keep the other fields intact
    //         "answer": "", // Update the changed field
    //     }))
    //     GetAnswersInfo()
    // };

    // single fetch for the answers list and search
    const GetAnswersInfo = async ({ page: pageNumber = 1, perPage: size = perPage, search = "", showLoader = true } = {}) => {
        const requestId = ++requestIdRef.current;
        showLoader ? setIsLoading(true) : setTableLoading(true)
        try {
            const response = await tmdbApi.answerInfo(pageNumber, size, search);
            // a newer request went out while this one was in flight - drop this response
            if (requestId !== requestIdRef.current) return;
            if (response?.result === "Invalid token or Expired") {
                setShowSessionPopupup(true)
            } else {
                const result = response?.result
                const rows = result?.answerData ?? result?.data ?? []
                // totalCount only comes back when the API paged the result; otherwise it sent every answer
                const backendPaged = typeof result?.totalCount === "number"

                // page is past the end (e.g. last row on the page was deleted) - step back one page
                if (backendPaged && rows.length === 0 && pageNumber > 1) {
                    setPage(pageNumber - 1)
                    GetAnswersInfo({ page: pageNumber - 1, perPage: size, search, showLoader })
                    return
                }

                setAnswers(rows)
                setServerPaging(backendPaged)
                setTotalRows(backendPaged ? result.totalCount : rows.length)
                setActiveSearch(search)
                setcontentLoaded(true)
            }
        } catch {
            if (requestId !== requestIdRef.current) return;
            console.log("error");
            setcontentLoaded(true)
        }
        if (requestId === requestIdRef.current) {
            setIsLoading(false)
            setTableLoading(false)
        }
    };


    const handleSubmit = async (e) => {
        // Prevent the function from running if already loading
        if (submitLoading) return;

        setSubmitLoading(true);
        GetTimeActivity();

        try {
            const isValid = formvalidation();
            if (isValid) {
                await createAnswer(formData); // Wait for this to complete
            }
        } catch (error) {
            console.log("Error in handleSubmit:", error);
        } finally {
            setSubmitLoading(false); // This will run after createAnswer completes
        }
    };


    function formvalidation() {
        GetTimeActivity()
        let formIsValid = true;

        if (formData?.answer == "") {
            setError((prevData) => ({
                ...prevData, // Keep the other fields intact
                ["answer"]: "Please enter Answer", // Update the changed field
            }));
            seterrorDisplay(true)
            setTimeout(function () { seterrorDisplay(false) }, 3000);
            formIsValid = false;
        } else {
            setError((prevData) => ({
                ...prevData, // Keep the other fields intact
                ["answer"]: "", // Update the changed field
            }));
        }

        return formIsValid;
    }

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevData) => ({
            ...prevData, // Keep the other fields intact
            [name]: value, // Update the changed field
        }));
    };

    // const onDelete = async (e) => {
    //     try {
    //         const response = await tmdbApi.deleteAnswer(deleteAnswerId);
    //         setDeleteSuccess(true)
    //         GetAnswersInfo()
    //     } catch {
    //         console.log("error");
    //     }
    //     setDeleteSuccess(true)
    //     setdeleteAnswer(false)

    // }
    const onDelete = async (e) => {
        try {
            const response = await tmdbApi.deleteAnswer(deleteAnswerId);
            setDeleteSuccess(true)

            reloadCurrentPage()
        } catch {
            console.log("error");
        }
        setDeleteSuccess(true)
        setdeleteAnswer(false)
    }
    const onCancel = (e) => {
        setdeleteAnswer(false)

    }

    const handleDelete = async (e, props) => {
        console.log('kisdfasdf')
        setdeleteAnswer(true)
        setDeleteAnswerId(props.answerid)
    }

    const handleSearchChange = (e) => {
        setSearch(e.target.value)
    }

    const clearSearch = () => {
        setSearch(null);
        setPage(1);
        GetAnswersInfo({ page: 1 })
    }

    const createAnswer = async (formData) => {
        try {
            let response;
            if (typeSelected == "Add") {
                response = await tmdbApi.AddAnswer(formData);
            } else {
                response = await tmdbApi.UpdateAnswer(formData, answerId);
            }
            if (response?.result === "Invalid token or Expired") {
                setShowSessionPopupup(true)
                // localStorage.clear();
                // navigate("/")
            } else if (response?.result === "Answer already exists"){
                setError((prevData) => ({
                ...prevData, // Keep the other fields intact
                ["answer"]: "This answer already exists", // Update the changed field
            }));
             seterrorDisplay(true)
            setTimeout(function () { seterrorDisplay(false) }, 3000);
        } else {
                setSuccess(true);
            }
            console.log(response);
            // if (response?.statusCode == 200) {

            //  }
        } catch {
            console.log("error");
        }
    };

    const customNoRecords = () => {
        return (

            <div className="empty-state-body empty-record"  >
                <div className="empty-state__message">
                    <span className="material-icons">summarize</span>
                    <p className="form-check font-size-16">No answers were found</p>
                </div> </div>
        )
    }

    console.log("errordataa", errorData);
    return (
        <>
            {showSessionPopupup && <SessionPopup />}
            <div id="layout-wrapper">
                <Header />
                <SideMenu />
                <div className="quiz-page main-content user-management clients company answers-page-section">

                    <div className="page-content">
                        <div className="container-fluid">
                            <div className="row mb-4 breadcrumb">
                                <div className="col-lg-12">
                                    <div className="d-flex align-items-center">
                                        <div className="flex-grow-1">
                                            <h4 className="mb-2 card-title">Answers</h4>

                                        </div>

                                        <div>
                                            <button onClick={(e) => handleShowPopup(e, 'Add')} className="btn btn-primary" disabled={isRestricted} >ADD</button>

                                        </div>


                                    </div>
                                </div>
                            </div>



                            <div className="row table-data">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-body">
                                            {isLoading ? <Loader /> :
                                                <>
                                                    <div className="row mb-2" id="table-header-row">
                                                        <div className="col-sm-4 button-block" id="button-block">
                                                            <div className="dataTables_length" id="datatable-length">

                                                            </div>
                                                        </div>
                                                        <div className="col-sm-8">
                                                            <div className="search-box mb-2 d-inline-block" id="search-box">

                                                                <div className="position-relative">
                                                                    <input type="text" className="form-control" value={searchvalue ? searchvalue : ""} onChange={(e) => handleSearchChange(e)} placeholder="Search " />
                                                                    <button className="fill_btn" onClick={(e) => handleSearch(e)}><span className="material-icons search-icon">search</span></button>
                                                                </div>

                                                                <div className="dataTables_length" id="datatable_length">
                                                                    <button className="fill_btn" onClick={(e) => clearSearch(e)}><span className="material-icons-outlined">sync</span>Reset</button>
                                                                </div>

                                                            </div>
                                                            <div className="text-sm-end">

                                                            </div>
                                                        </div>
                                                    </div>


                                                    < DataTable key={keyForRerender}
                                                        // title=""
                                                        columns={columns}
                                                        // className="table align-middle table-nowrap table-check"
                                                        keyField='_id'
                                                        data={answersdata}
                                                        direction="auto"
                                                        highlightOnHover

                                                        fixedHeaderScrollHeight="300px"
                                                        pagination
                                                        paginationServer={serverPaging}
                                                        responsive
                                                        noDataComponent={customNoRecords()}
                                                        persistTableHead
                                                        striped

                                                        subHeaderAlign="right"
                                                        defaultSortField="name"
                                                        subHeaderWra
                                                        paginationTotalRows={totalRows}
                                                        onChangeRowsPerPage={handlePerRowsChange}
                                                        onChangePage={handlePageChange}
                                                        paginationPerPage={perPage}
                                                        paginationDefaultPage={page}
                                                        paginationRowsPerPageOptions={[15, 25, 50, 75, 100]}
                                                        sortFunction={customSort}

                                                        paginationComponentOptions={{
                                                            rowsPerPageText: 'Per page:',
                                                            rangeSeparatorText: 'of',
                                                            noRowsPerPage: false,
                                                            selectAllRowsItem: false,
                                                            selectAllRowsItemText: 'All',
                                                        }}
                                                        progressPending={tableLoading}
                                                        progressComponent={<Loader />}
                                                    />
                                                </>


                                            }


                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                    <SweetAlert show={success}
                        custom
                        confirmBtnText="ok"
                        confirmBtnBsStyle="primary"
                        title={typeSelected == "Add" ? "Answer Added Successfully" : "Answer Updated Successfully"}
                        onConfirm={e => onConfirm()}
                    >
                    </SweetAlert>

                    <SweetAlert show={deleteAnswer}
                        warning
                        showCancel
                        confirmBtnText="Yes"
                        cancelBtnText="Cancel"
                        confirmBtnBsStyle="danger"
                        cancelBtnBsStyle="default"
                        title="Are you sure to delete the Answer?"
                        focusCancelBtn
                        onConfirm={e => onDelete()}
                        onCancel={e => onCancel()}
                    >
                    </SweetAlert>

                    <Modal className="advance-search search-popup" show={popup} onHide={handleClosePopup} backdrop="static">
                        <Modal.Header closeButton>
                            <Modal.Title>{typeSelected == "Add" ? `Add` : `Update`} Answer</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div>

                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="input-field">
                                            <label className="col-form-label">Answer</label>
                                            <input className="form-control" placeholder="Enter Answer" type="text" name="answer" onChange={(e) => handleChange(e)}
                                                value={formData?.answer} />
                                            {errorDisplay && <span className="errormsg" style={{
                                                fontWeight: 'bold',
                                                color: 'red',
                                            }}>{errorData?.answer}</span>}
                                        </div>
                                    </div>



                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <div className="">

                                <button
                                    className="submit-quiz-btn border-0"
                                    style={{
                                        cursor: submitLoading ? "not-allowed" : "pointer",
                                        opacity: submitLoading ? 0.7 : 1
                                    }}
                                    onClick={handleSubmit}
                                >
                                    {submitLoading && (
                                        <img
                                            src={rotate_right}
                                            className="loading-icon"
                                            id="loginPwdLoading"
                                            alt="loading"
                                            style={{
                                                animation: 'spin 1s linear infinite',
                                                marginRight: '8px'
                                            }}
                                        />
                                    )}
                                    {submitLoading ? "SUBMITTING..." : "SUBMIT"}
                                </button>

                                <div className="clearfix"></div>
                            </div>
                        </Modal.Footer>
                    </Modal>

                    <ToastContainer
                        position="bottom-center"
                        autoClose={3000}
                        hideProgressBar={false}
                        newestOnTop
                        closeOnClick
                        pauseOnHover
                        draggable
                    />

                    <Footer />
                </div>


            </div>
        </>
    );
};

export default Answers;

